export class SystemThermalMethodMapping {
  systemName: string;
  code: number | null;
  methodName: string;

  constructor(row: Record<string, string | number | null>) {
    this.systemName = row['systemName'] as string;
    this.code = row['code'] as number | null;
    this.methodName = row['methodName'] as string;
  }
}